document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('.wm-product-page');
  if(!root)return;
  var logoUrl=document.body.getAttribute('data-wm-product-logo');
  var videoItems=Array.from(root.querySelectorAll('.wm-product-media-item')).filter(function(item){return item.querySelector('video')});
  if(!videoItems.length)return;

  videoItems.forEach(function(item){
    var video=item.querySelector('video');
    var wasActive=false;
    item.classList.add('wm-product-media-item--video');
    video.autoplay=false;
    video.loop=false;
    video.muted=true;
    video.defaultMuted=true;
    video.playsInline=true;
    video.controls=false;
    video.removeAttribute('autoplay');
    video.removeAttribute('loop');
    video.setAttribute('muted','');
    video.setAttribute('playsinline','');
    video.removeAttribute('controls');

    if(logoUrl&&!item.querySelector('.wm-product-video-logo')){
      var logoWrap=document.createElement('div');
      logoWrap.className='wm-product-video-logo';
      var logo=document.createElement('img');
      logo.src=logoUrl;
      logo.alt='';
      logo.loading='lazy';
      logoWrap.appendChild(logo);
      var caption=document.createElement('p');
      caption.className='wm-product-video-caption';
      caption.textContent='Wear a little wonder.';
      logoWrap.appendChild(caption);
      item.appendChild(logoWrap);
    }

    function syncPlayback(){
      var isActive=item.classList.contains('is-active');
      if(isActive&&!wasActive){
        video.currentTime=0;
        var playPromise=video.play();
        if(playPromise&&typeof playPromise.catch==='function')playPromise.catch(function(){});
      }else if(!isActive){
        video.pause();
        video.currentTime=0;
      }
      wasActive=isActive;
    }
    new MutationObserver(syncPlayback).observe(item,{attributes:true,attributeFilter:['class']});
    syncPlayback();
  });
});
